import { ApiClient } from "@aiskills/ui-kit";

/**
 * Single ApiClient instance reused by every page. baseUrl is resolved
 * from the Vite env; during local dev the dev-server proxy forwards
 * /v1 to http://localhost:8000 so `""` (same-origin) Just Works.
 */
const baseUrl = (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? "";

export const api = new ApiClient({
  baseUrl,
  onUnauthenticated: () => {
    if (window.location.pathname !== "/login") {
      window.location.href = "/login";
    }
  },
});
